module.exports = __webpack_public_path__ + "img/person_chenhaitao.017660e2.jpg";